<script lang="ts">
</script>

<section class="mosaic-course-modules">
  <slot />
</section>

<style type="text/scss" lang="scss" scoped>
  .mosaic-course-modules {
    @apply grid md:grid-cols-2 items-start grid-flow-row-dense;
    @apply gap-grid-default;
  }
</style>
